import * as types from '../../actions/actionsTypes/pianificazioneCalendarioActionsType'

import {dayJS} from "../../applicationConf";

export const initialStatePianificazioneCalendario = {
    pianificazioneCalendario: [],
    estremi: null,
    allPlanning: false,
    loadingPianificazione: true,
    actualView: 'month',
    label_month: null,
    error: null
};

export const pianificazioneCalendarioReducer = (state = initialStatePianificazioneCalendario, action) => {
    switch (action.type) {
        case types.INIT_PIANIFICAZIONE_CALENDARIO :
            return {
                ...state,
                pianificazioneCalendario: [],
                estremi: null,
                error: null,
                loadingPianificazione: true
            };

        case types.INIT_CUSTOM_TOOLBAR :
            return {
                ...state,
                actualView: 'month',
                label_month: null,
                allPlanning: false
            };

        case types.RESET_PIANIFICAZIONI_CALENDARIO_FILTRO :
            return {
                ...state,
                pianificazioneCalendario: [],
                loadingPianificazione: true
            };

        case types.SAVE_ESTREMI : {
            return {
                ...state,
                estremi: action.estremi,
                label_month: dayJS(action.estremi.meseDaVisualizzare).isBefore(action.estremi.meseInizio) ?
                    dayJS(action.estremi.meseInizio).startOf('month').format('YYYY-MM-DD') :
                    dayJS(action.estremi.meseDaVisualizzare).startOf('month').format('YYYY-MM-DD')
            }
        }

        case types.GET_PIANIFICAZIONE_CALENDARIO_SUCCESS : {
            return {
                ...state,
                pianificazioneCalendario: action.pianificazioneCalendario,
                loadingPianificazione: false
            };
        }

        case types.GET_PIANIFICAZIONE_CALENDARIO_FAIL :
            return {
                ...state,
                error: action.error,
                loadingPianificazione: false
            };

        case types.ALL_PLANNING :
            return {
                ...state,
                allPlanning: !action.viewBool
            };

        case types.LABEL_MONTH_AGENDA :
            return {
                ...state,
                actualView: action.obj_label_month.actualView,
                label_month: action.obj_label_month.label_month
            };

        case types.SET_MONTH :
            return {
                ...state,
                label_month: action.month
            };

        case types.PIANIFICAZIONE_CALENDARIO_RICERCA_SUCCESS : {
            return {
                ...state,
                pianificazioneGiornata: action.pianificazioneGiornata
            };
        }

        case types.PIANIFICAZIONE_CALENDARIO_RICERCA_FAIL :
            return {
                ...state,
                pianificazioneGiornata: [],
                error: action.error
            };
        default:
            return state;
    }
};


